import AuthContext from "context/AuthContext";
import { useContext } from "react";
import TableAlertsWaste from "./waste/TableAlertsWaste";
import TableAlertsBridge from "./bridge/TableAlertsBridge";

const TableAlertsManager = (props) => {
    const { panel } = useContext(AuthContext);

    switch (panel.panel_type) {
        case 'b':
            return <TableAlertsBridge {...props} />;
        default:
            return <TableAlertsWaste {...props} />;
    }
};
export default TableAlertsManager;